












import Vue from "vue";
import countries from "@/globals/countries";
import config from "@/configs";
import VueI18n from "vue-i18n";
import TranslateResult = VueI18n.TranslateResult;

interface CountryOption {
  code: string;
  name: TranslateResult;
}

interface Data {
  selected: string | undefined;
  countries: CountryOption[];
}

export default Vue.extend({
  name: "CountrySelect",
  mounted() {
    const supportedCountries = config?.settings.supportedCountries || [];

    countries.forEach((country) => {
      if (supportedCountries.includes(country.code)) {
        this.countries.push({
          code: country.code,
          name: this.$t(`countries.${country.code}`),
        });
      }
    });

    this.selected = config?.settings.defaultCountry;
    this.onChange();
  },
  data(): Data {
    return {
      selected: undefined,
      countries: [],
    };
  },
  methods: {
    onChange() {
      this.$emit("changed", this.selected);
    },
  },
});
